(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('TradePolicyDeleteController',TradePolicyDeleteController);

    TradePolicyDeleteController.$inject = ['$uibModalInstance', 'entity', 'TradePolicy'];

    function TradePolicyDeleteController($uibModalInstance, entity, TradePolicy) {
        var vm = this;
        vm.tradePolicy = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            TradePolicy.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
